import React from "react";
import { ErrorPage, OfflinePage } from "./StatusPages";

export function NetworkStatusBoundary({ children }) {
  const [online, setOnline] = React.useState(() => navigator.onLine);

  React.useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return online ? children : <OfflinePage/>;
}

export class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Uncaught application error", error, info);
  }

  render() {
    if (this.state.error) {
      return <ErrorPage onRetry={() => this.setState({ error: null })}/>;
    }

    return this.props.children;
  }
}